import { Bounds, ImageOverlay, LatLngBounds, Map, Proj } from 'leaflet';
import { ReactElement, useEffect } from 'react';
import { useMap } from 'react-leaflet';

export interface ICustomImageOverlayProps {
	url: string;
	bounds: LatLngBounds;
	crs?: Proj.CRS;
}

export function CustomImageOverlay(
	props: ICustomImageOverlayProps
): ReactElement {
	const { url, bounds, crs } = props;
	const map: Map = useMap();

	useEffect(() => {
		const imageOverlay: ImageOverlay = crs
			? createCrsImageLayer()
			: createImageLayer();

		return () => {
			if (imageOverlay && map) {
				map.removeLayer(imageOverlay);
			}
		};
	}, []);

	function createCrsImageLayer(): ImageOverlay {
		const projectedBounds: Bounds = new Bounds(
			crs!.project(bounds.getSouthEast()),
			crs!.project(bounds.getNorthWest())
		);
		const imageOverlay = new Proj.ImageOverlay(
			url,
			projectedBounds as unknown as LatLngBounds,
			{
				className: 'image-overlay'
			}
		).addTo(map);

		return imageOverlay;
	}

	function createImageLayer(): Proj.ImageOverlay {
		const imageOverlay = new ImageOverlay(url, bounds, {
			className: 'image-overlay'
		}).addTo(map);

		return imageOverlay;
	}

	return <></>;
}
